var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_111_3426",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#111111"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_111_3426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.6947 16.8373H3.33325V5.09036H4.89952V2.5H11.8875V4.8494H13.0923V9.12651",
    stroke: "#111111",
    strokeOpacity: 0.5,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0924 15.331C14.3566 15.331 15.3815 14.3061 15.3815 13.0418C15.3815 11.7776 14.3566 10.7527 13.0924 10.7527C11.8281 10.7527 10.8032 11.7776 10.8032 13.0418C10.8032 14.3061 11.8281 15.331 13.0924 15.331ZM13.0924 14.1264C13.6913 14.1264 14.1767 13.641 14.1767 13.0421C14.1767 12.4432 13.6913 11.9578 13.0924 11.9578C12.4935 11.9578 12.0081 12.4432 12.0081 13.0421C12.0081 13.641 12.4935 14.1264 13.0924 14.1264Z",
    fill: "#111111",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.63132 17.5C9.86598 15.7983 11.3261 14.4877 13.0924 14.4877C14.8586 14.4877 16.3188 15.7983 16.5534 17.5H15.231C15.0589 16.4744 14.1669 15.6929 13.0923 15.6929C12.0178 15.6929 11.1258 16.4744 10.9537 17.5H9.63132Z",
    fill: "#111111",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.46582,
    y: 4.48804,
    width: 3.61446,
    height: 1.20482,
    fill: "#111111",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.26099,
    y: 6.89746,
    width: 1.20482,
    height: 1.20482,
    fill: "#111111",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.26099,
    y: 9.18652,
    width: 1.20482,
    height: 1.20482,
    fill: "#111111",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.26099,
    y: 11.4758,
    width: 1.20482,
    height: 1.20482,
    fill: "#111111",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.26099,
    y: 13.7651,
    width: 1.20482,
    height: 1.20482,
    fill: "#111111",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.67065,
    y: 6.89746,
    width: 1.20482,
    height: 1.20482,
    fill: "#111111",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.67065,
    y: 9.18652,
    width: 1.20482,
    height: 1.20482,
    fill: "#111111",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.67065,
    y: 11.4758,
    width: 1.20482,
    height: 1.20482,
    fill: "#111111",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.67065,
    y: 13.7651,
    width: 1.20482,
    height: 1.20482,
    fill: "#111111",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.0803,
    y: 6.89746,
    width: 1.20482,
    height: 1.20482,
    fill: "#111111",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.0803,
    y: 9.18652,
    width: 1.20482,
    height: 1.20482,
    fill: "#111111",
    fillOpacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.6cdb75a63e42c5e46ac102569d17da0a.svg";
export { ForwardRef as ReactComponent };